import { useEffect, useState } from 'react';
import { isAuctionWaitingForEnd } from '../utils/auctionUtils';
import { AuctionDto } from '../../../services/Auction/auctionService.dto';
import ItemForm from '../../items/components/form/ItemForm';
import { usePopup } from '../../../providers/PopupProvider';
import { useAuctionEndDetection } from './useAuctionEndDetection';

export const useAuctionEdit = (auction?: AuctionDto, onAuctionSaved?: () => void) => {
  const { showPopover, hidePopover } = usePopup();
  const [canEditAuction, setCanEditAuction] = useState(false);

  useAuctionEndDetection(auction, () => setCanEditAuction(false));

  useEffect(() => {
    setCanEditAuction(deriveCanEditAuction(auction));
  }, [auction]);

  const handleAuctionSaved = () => {
    hidePopover();
    onAuctionSaved?.();
  };

  const showEditAuctionPopup = () => {
    if (auction) {
      showPopover(<ItemForm itemId={auction.itemId} onItemSaved={handleAuctionSaved} />);
    }
  };

  return { canEditAuction, showEditAuctionPopup };
};

const deriveCanEditAuction = (auction?: AuctionDto) =>
  !!auction && ((auction.status === 'ONGOING' && !isAuctionWaitingForEnd(auction)) || auction.status === 'CANCELED');
